module.exports = __webpack_public_path__ + "static/img/r4.09773419.png";